import { FinalMemberRow } from "./FinalMemberRow";
import type { FinalPanelMemberData } from "./types";

interface FinalPanelMemberListViewProps {
	finalMembers: FinalPanelMemberData[];
}

export const FinalPanelMemberListView: React.FC<FinalPanelMemberListViewProps> = ({ finalMembers }) => {
	if (finalMembers.length === 0) {
		return (
			<div
				className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm"
				data-testid="panel-member-list-empty"
			>
				No panel member final scoring progress available yet.
			</div>
		);
	}

	const submittedCount = finalMembers.filter((m) => m.isSubmitted).length;

	return (
		<div data-testid="panel-member-list">
			<div className="mb-3 flex items-center justify-between">
				<h4 className="text-sm font-medium text-gray-700">
					Final Scoring Progress
				</h4>
				<span className="text-xs text-gray-500">
					{submittedCount} of {finalMembers.length} submitted
				</span>
			</div>
			<div className="w-full overflow-x-auto">
				<table className="w-full min-w-[600px] border-collapse text-sm">
					<thead>
						<tr className="border-b border-gray-200 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
							<th className="px-3 py-3">Member</th>
							<th className="px-3 py-3">Role</th>
							<th className="px-3 py-3">Progress</th>
							<th className="px-3 py-3">Status</th>
							<th className="px-3 py-3">Submitted</th>
						</tr>
					</thead>
					<tbody>
						{finalMembers.map((member) => (
							<FinalMemberRow key={member.memberId} member={member} />
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
